/* eslint-disable max-len */
/* eslint-disable no-unexpected-multiline */
import React from 'react'
import {connect} from 'react-redux'
import {Modal} from '@lazarusai/forms-ui-components'
import '../styles/ResourcesModal.css'

import workflowResources from '../Workflow_Resources.json'

// Actions
import {storePayload} from '../actions/storePayload.js'

function ResourcesModal(props) {
  // Split string with colon into array
  function splitStr(str) {
    let arr = [str]
    if (str) {
      const iOfColon = str.indexOf(':')
      if (iOfColon !== -1) {
        const a = str.slice(0, iOfColon)
        const b = str.slice(iOfColon + 1, str.length)
        arr = [a, b]
      }
    }
    return arr
  }
  console.log('data: ', props.refData)
  const content = (
    <div className='resources-modal-content'>
      <p className='modal-header'>{props.headerText}</p>
      <div className='resource-cards'>
        <p
          className='modal-subheader'
        >
          {props.subheaderText}
        </p>
        <div>
          {
            // eslint-disable-next-line max-len
            workflowResources?.[props.selectedSectionName]?.[props.selectedSubSectionName]?.urls
                .map((url, i) => {
                  const resource =
                    workflowResources
                        [props.selectedSectionName]
                        [props.selectedSubSectionName]
                  const isUrl =
                    workflowResources?.[props.selectedSectionName]?.[props.selectedSubSectionName]?.headers?.[i]
                  let contractNum
                  let contractTitle
                  if (!isUrl) {
                    contractTitle = splitStr(url)[0]
                    contractNum = splitStr(url)[1]
                  }

                  if (isUrl) {
                    return (
                      <div
                        className='resource-card'
                        key={`resource-${i}`}
                      >
                        <div>
                          {contractTitle ?
                            <p className='resource-card-title'>
                              {contractTitle}
                            </p> :
                            <p className='resource-card-title'>
                              {splitStr(resource.headers[i])[0]}
                            </p>
                          }
                          <p className='resource-card-description'>
                            {splitStr(resource.headers[i])[1]}
                          </p>
                        </div>
                        {contractNum ?
                          <p className='resource-card-num'>
                            {contractNum}
                          </p> :
                          <a
                            href={url}
                            target='_blank'
                            rel="noreferrer"
                          >
                            Visit Website
                          </a>
                        }
                      </div>
                    )
                  } else {
                    return <></>
                  }
                })
          }
        </div>
      </div>
    </div>
  )
  return (
    <Modal
      isVisible={props.isVisible}
      showClose={true}
      showCancel={false}
      showConfirm={false}
      showBackdrop={true}
      outsideClickDismisses={true}
      content={content}
      theme={props.theme}
      onCancel={props.onCancel}
    />
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSubSection: state.userReducer.selectedSubSection,
  isResourcesModal: state.userReducer.isResourcesModal,
  isResourcesModalShowing: state.userReducer.isResourcesModalShowing,
  selectedSectionIndex: state.userReducer.selectedSectionIndex,
  selectedSectionName: state.userReducer.selectedSectionName,
  selectedSubSectionIndex: state.userReducer.selectedSubSectionIndex,
  selectedSubSectionName: state.userReducer.selectedSubSectionName,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(ResourcesModal)
